




import { createComponent, ref } from "@vue/composition-api";
import _ from "lodash";

interface Props {
  value: string;
  debounce: number;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true },
    debounce: { default: 200 },
  },
  setup(props, ctx) {
    const internalValue = ref(props.value);

    function emitValue(val: string) {
      ctx.emit("input", val);
    }
    const debouncedEmitValue = _.debounce(emitValue, props.debounce);

    function onInput(val: string) {
      internalValue.value = val;
      debouncedEmitValue(val);
    }

    return { onInput, internalValue };
  },
});
